module.exports = __webpack_public_path__ + "static/media/eduTechImg2@2x.37c7d9ed.jpg";